export enum WeekDay {
	Monday = 'Monday',
	Tuesday = 'Tuesday',
	Wednesday = 'Wednesday',
	Thursday = 'Thursday',
	Friday = 'Friday',
	Saturday = 'Saturday',
	Sunday = 'Sunday',
}

export interface ITime {
	hours: number
	minutes: number
}

export interface IDateRange {
	start?: Date
	end?: Date
}

export interface ITimeRange {
	start?: ITime
	end?: ITime
}
